import get from 'lodash/get';

import {
  PERSONAL_ROLE,
  PROFESSIONAL_ROLE,
  BROKER_ROLE,
} from './types';

export const getUserPhonesFromProtectedData = protectedData => {
  return get(protectedData, 'phones', []);
};

export const getUserPhonesFromUser = user => {
  const userProtectedData = get(user, 'attributes.profile.protectedData', null);
  return getUserPhonesFromProtectedData(userProtectedData);
};

export const getFullUserPhoneFromUser = (user, phoneValue) => {
  const userPhones = getUserPhonesFromUser(user);
  return userPhones.find(i => i.phone.value === phoneValue);
};

export const getFullUserPhoneFromProtectedData = (protectedData, phoneValue) => {
  const userPhones = getUserPhonesFromProtectedData(protectedData);
  return userPhones.find(i => i.phone.value === phoneValue);
};

export const getTrackingByPhoneFromUser = (user, phoneValue) => {
  return get(getFullUserPhoneFromUser(user, phoneValue), 'tracking', null);
};

export const getDefaultPhoneFromUser = user => {
  const phones = getUserPhonesFromUser(user);
  const phone = phones.find(i => i.isDefault === true);
  return phone ? phone : null;
};

export const getDefaultPhoneValueFromUser = user => {
  const verifiedPhone = getDefaultPhoneFromUser(user);
  return get(verifiedPhone, 'phone.value', null);
};
export const getTrackingByPhoneFromProtectedData = (protectedData, phoneValue) => {
  const userPhones = getUserPhonesFromProtectedData(protectedData);
  const fullPhone = userPhones.find(i => i.phone.value === phoneValue);
  return get(fullPhone, 'tracking', null);
};

export const getTrackingPhoneValue = tracking => {
  return get(tracking, 'number', '');
};

export const getDefaultPhoneFromProtectedData = (protectedData) => {
  const userPhones = getUserPhonesFromProtectedData(protectedData);
  return userPhones.find(i => i.isDefault);
};

export const getDefaultPhoneValueFromProtectedData = protectedData => {
  const defaultPhone = getDefaultPhoneFromProtectedData(protectedData);
  return get(defaultPhone, 'phone.value', '');
};

export const getVerifiedPhoneUser = user => {
  const userPhones = getUserPhonesFromUser(user);
  return userPhones.find(i => (i.isDefault && i.isVerified) || i.isVerified);
};

export const getVerifiedPhoneValueFromUser = user => {
  const verifiedPhone = getVerifiedPhoneUser(user);
  return get(verifiedPhone, 'phone.value', null);
};

export const isPhonesEqual = (phone1, phone2) => {
  const phone1Value = get(phone1, 'phone.value', null);
  const phone2Value = get(phone2, 'phone.value', null);
  return phone1Value === phone2Value;
};

export const getUserFullName = user => {
  const firstName = get(user, 'attributes.profile.firstName', '');
  const lastName = get(user, 'attributes.profile.lastName', '');
  return `${firstName} ${lastName}`;
};

export const getCompanyName = user => {
  return get(user, 'attributes.profile.publicData.companyName', null);
}

export const getUserEmail = user => {
  return get(user, 'attributes.email', null);
}

export const getBrokerAssignedListings = user => {
  return get(user, 'attributes.profile.protectedData.created_listings', []);
};

export const getBrokerAssignedListingsCount = user => {
  return getBrokerAssignedListings(user).length;
};

export const getUserDisplayName = user => {
  return get(user, 'attributes.profile.displayName', '');
};

export const getUserUUID = user => {
  return get(user, 'id.uuid', null);
};

export const getDealerId = (user) => {
  return get(user, 'attributes.profile.protectedData.dealerId', null);
}

export const getIsBrokerAccount = user => {
  return !!getDealerId(user);
};

export const getUserRole = user => {
  return get(user, 'attributes.profile.publicData.userRole', null);
};

export const isPersonalRole = user => {
  return getUserRole(user) === PERSONAL_ROLE;
};

export const isProfessionalRole = user => {
  return getUserRole(user) === PROFESSIONAL_ROLE;
};

export const getIsBrokerRole = user => {
  return getUserRole(user) === BROKER_ROLE;
};

export const getIsInactiveBroker = user => {
  const dealerId = getDealerId(user);
  return getIsBrokerRole(user) && !dealerId;
};

export const getChargebeeSubscription = user => {
  return get(
    user,
    'attributes.profile.protectedData.chargebeeSubscription',
    null
  );
};
